module.exports = __webpack_public_path__ + "static/media/vacation.c84a7253.jpeg";